module.exports = __webpack_public_path__ + "static/media/third.2be92c34.svg";